module.exports = __webpack_public_path__ + "0f26dee934d6b771465e77fbf682bbae.svg";